<template>
  <footer class="footer" :class="{'home': $route.path === '/'}">
    <div class="footer__content">
      <div class="footer__logo"></div>
      <div class="footer__columns">
        <div class="footer__pages">
          <div class="footer__pages-title">Weinreisen</div>
          <router-link
            v-for="tour in getTourList()"
            :key="tour.id"
            :to="`/${tour.id}`"
            class="footer__pages-link"
          >{{tour.title}}</router-link>
        </div>
        <div class="footer__contact">
          <div class="footer__contact-title">Kontakt</div>
          <div class="footer__contact-label">Mobil</div>
          <div class="footer__contact-text">0176 / 834 915 08</div>
          <div class="footer__contact-label">Festnetz</div>
          <div class="footer__contact-text">0821 / 297 53 911</div>
          <div class="footer__contact-label">Mail</div>
          <a
            class="footer__mail"
            href="mailto:info@auszeit-weinreisen.de"
          >info@auszeit-weinreisen.de</a>
        </div>
      </div>
    </div>
    <div class="footer__bar">
      <div>
        <router-link class="footer__bar-links" to="/impressum">Impressum</router-link>
        <router-link class="footer__bar-links" to="/datenschutz">Datenschutz</router-link>
        <router-link class="footer__bar-links" to="/reisebedingungen">Reisebedingungen</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<style scoped lang="scss">
.footer {
  box-shadow: 0 4px 40px -20px rgba(13, 13, 13, 0.2);
  position: relative;

  &.home {
    .footer__content {
      position: absolute;
      bottom: 40px;
      left: 0;
      right: 0;
    }
  }
}

.footer__content {
  max-height: 282px;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(127, 115, 113, 0.7);
  padding: 52px;
}

.footer__logo {
  max-width: 705px;
  height: 32px;
  background: url("../../../assets/a.svg") no-repeat;
  margin: 0 auto 32px;
}

.footer__columns {
  max-width: 705px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.footer__contact,
.footer__pages {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 48%;
}

.footer__contact-title,
.footer__pages-title {
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #ffffff;
  text-align: left;
  min-width: 100%;
  margin-bottom: 12px;
}

.footer__pages-link {
  line-height: 20px;
  opacity: 0.7;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  //font-weight: 300;
  letter-spacing: 0.2px;
  color: #ffffff;
  text-align: left;
  min-width: 50%;
  margin-bottom: 8px;
  text-decoration: none;
}

.footer__contact-label {
  line-height: 20px;
  opacity: 0.7;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  //font-weight: 300;
  letter-spacing: 0.2px;
  color: #ffffff;
  text-align: left;
  min-width: 86px;
  margin-bottom: 8px;
}

.footer__contact-text {
  line-height: 20px;
  opacity: 0.7;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  //font-weight: 300;
  letter-spacing: 0.2px;
  color: #ffffff;
  text-align: left;
  min-width: calc(100% - 86px);
  margin-bottom: 8px;
}

.footer__bar {
  background-color: #7f7371;
  max-height: 40px;
  padding: 0 48px;

  > div {
    text-align: left;
    max-width: 705px;
    margin: auto;
  }
}

.footer__bar-links {
  line-height: 16px;
  font-size: 14px;
  letter-spacing: 0.18px;
  color: #ffffff;
  display: inline-block;
  margin: 12px 16px 12px 0;
  text-align: left;
  text-decoration: none;
}

.footer__mail {
  line-height: 20px;
  opacity: 0.7;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  //font-weight: 300;
  letter-spacing: 0.2px;
  color: #ffffff;
  text-align: left;
  min-width: 50%;
  margin-bottom: 8px;
  text-decoration: none;
}

@media (max-width: 767px) {
  .footer__content {
    max-height: 392px;
    padding: 32px;
  }

  .footer__columns {
    flex-direction: column-reverse;
  }

  .footer__contact {
    width: 100%;
    margin-bottom: 24px;
  }

  .footer__contact-label {
    min-width: 75px;
  }

  .footer__pages {
    width: 100%;
  }

  .footer__pages-link {
    min-width: calc(50% + 8px);

    &:nth-child(odd) {
      min-width: calc(50% - 8px);
    }
  }

  .footer__bar {
    padding: 0 0 0 32px;
  }

  .footer__bar-links {
    margin: 12px 10px 12px 0;

    &:last-of-type {
      margin: 12px 0 12px 0;
    }
  }
}
</style>
